import axios from "axios";

// API Local: "http://localhost:8010/api/"

const axiosAPI = axios.create({
  baseURL: "http://api.easyvog.com.br/api/",
  timeout: 300000, // 5 minutes,
});

function parseStoredUser() {
  const storedUser = localStorage.getItem("user");
  if (!storedUser || storedUser === "undefined") {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch (e) {
    console.error("Erro ao parsear usuário do localStorage:", e);
    return null;
  }
}

axiosAPI.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const response = error?.response;
    const responseData = response?.data || {};

    if (response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      axiosAPI.defaults.headers.Authorization = undefined;

      window.location.replace("/login");
    }

    // Detectar expiração do FREE por chave técnica do backend.
    const isStructuredFreeExpiredError =
      responseData.error === "free_plan_expired";
    const hasFreeExpirationPayload =
      response?.status === 403 &&
      ("expiration_date" in responseData ||
        "period_type" in responseData ||
        "is_legacy_user" in responseData);

    if (isStructuredFreeExpiredError || hasFreeExpirationPayload) {
      const currentUser = parseStoredUser();
      const updatedUser = currentUser ? { ...currentUser } : {};

      updatedUser.is_free_expired = true;
      updatedUser.free_expired_message =
        responseData.message || updatedUser.free_expired_message || null;

      if (responseData.expiration_date) {
        updatedUser.free_expiration_date = responseData.expiration_date;
      }

      if (typeof responseData.is_legacy_user === "boolean") {
        updatedUser.is_legacy_user = responseData.is_legacy_user;
      }

      if (typeof responseData.period_type === "string") {
        updatedUser.period_type = responseData.period_type;
      }

      localStorage.setItem("user", JSON.stringify(updatedUser));

      // Disparar evento para atualizar estado React sem reload.
      window.dispatchEvent(
        new CustomEvent("freePlanExpired", {
          detail: {
            message: responseData.message || responseData.error || "",
            userData: updatedUser,
          },
        })
      );
    }

    return Promise.reject(response);
  }
);

export default axiosAPI;
